import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=2cf30bfa&scoped=true&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=2cf30bfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf30bfa",
  null
  
)

export default component.exports